import { gql } from '@apollo/client'

// GraphQL Mutation - Regenerate token
export const REGENERATE_TOKEN = gql`
  mutation RegenerateToken($refreshToken: String!) {
    regenerateToken(input: { refreshToken: $refreshToken }) {
      accessToken
    }
  }
`

/**
 * Graphql Mutation - InitiateAuthOrSignup
 * @param emailOrPhone: String value either valid phone number or email
 * @param countryCode: Optional countryCode, if emailOrPhone contains phone number then countryCode value should be send
 */
export const INITIATE_AUTH_OR_SIGNUP = gql`
  mutation InitiateAuthOrSignup($emailOrPhone: String!, $countryCode: String, $createdVia: CreatedVia!) {
    initiateAuthOrSignup(input: { emailOrPhone: $emailOrPhone, countryCode: $countryCode, createdVia: $createdVia }) {
      userID
      session
      emailOrPhone
    }
  }
`

/**
 * Graphql Mutation - To revoke user token
 * @param refreshToken: String value which will get from token service
 */
export const REVOKE_USER_TOKEN = gql`
  mutation RevokeToken($refreshToken: String!) {
    revokeToken(input: { refreshToken: $refreshToken })
  }
`

/**
 * Graphql Mutation - VerifyCode
 * @param userID: String value which client getting from InitiateAuthOrSignup step
 * @param code: a verification code, which user got on their phone number or email
 * @param session: a session string which client getting from InitiateAuthOrSignup step
 */
export const VERIFY_CODE = gql`
  mutation VerifyCode($userID: String!, $code: String!, $session: String!) {
    verifyCode(input: { userID: $userID, code: $code, session: $session }) {
      accessToken
      refreshToken
      status
    }
  }
`

/**
 * This mutation is used to create username
 * @param username is the username that we generate based on the entered name by user.
 */
export const CREATE_USERNAME = gql`
  mutation CreateUsername($username: String!) {
    createUsername(input: { username: $username }) {
      id
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUserDetails($name: String!, $colorModePreference: String) {
    updateUserDetails(input: { name: $name, colorModePreference: $colorModePreference }) {
      id
    }
  }
`
